module.exports = __webpack_public_path__ + "img/statistics.e6342c42.svg";